import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { sendTrackEvent } from '@edx/frontend-platform/analytics';
import { ensureConfig } from '@edx/frontend-platform/config';
import { AppContext } from '@edx/frontend-platform/react';
import messages from './Footer.messages';
import LanguageSelector from './LanguageSelector';
import Facebook from "./facebook.svg";
import Instagram from "./instagram.svg";
import Twitter from "./twitter.svg";
import  Youtube from "./youtube.svg";

ensureConfig([
  'LMS_BASE_URL',
  'LOGO_TRADEMARK_URL',
], 'Footer component');

const EVENT_NAMES = {
  FOOTER_LINK: 'edx.bi.footer.link',
};

class SiteFooter extends React.Component {
  constructor(props) {
    super(props);
    this.externalLinkClickHandler = this.externalLinkClickHandler.bind(this);
  }

  externalLinkClickHandler(event) {
    const label = event.currentTarget.getAttribute('href');
    const eventName = EVENT_NAMES.FOOTER_LINK;
    const properties = {
      category: 'outbound_link',
      label,
    };
    sendTrackEvent(eventName, properties);
  }


  // loadExternalScript() {
  //   const script = document.createElement('script');
  //   script.src = 'https://ueg.eu/widgets/socialMediaCounter';
  //   script.async = true;
  //   document.body.appendChild(script);
  // }

  // componentDidMount() {
    
  //   this.loadExternalScript();
  // }

  // componentDidUpdate() {
    
  //   this.loadExternalScript();
  // }

  render() {
    const {
      supportedLanguages,
      onLanguageSelected,
      logo,
      intl,
    } = this.props;
    const showLanguageSelector = supportedLanguages.length > 0 && onLanguageSelected;
    const { config } = this.context;

    return (
      <div className='footer-container'>
      <footer
        role="contentinfo"
        className="footer border-top py-3 px-4"
      >

        <div className="container-fluid footer-wrapper">
          {/* <a
            className="d-block"
            href={config.LMS_BASE_URL}
            aria-label={intl.formatMessage(messages['footer.logo.ariaLabel'])}
          > */}
          {/* <div className="flex-grow-1" />
          {showLanguageSelector && (
            <LanguageSelector
              options={supportedLanguages}
              onSubmit={onLanguageSelected}
            />
          )} */}

          


          <div class="footer-main-col">
          <p>UEG Secretariat</p>
        <br/>
          <p>United European Gastroenterology&nbsp;</p>
          <p>
            House of European Gastroenterology<br/>
            Wickenburggasse 1<br/>
            1080 Vienna, Austria</p>
          <p>
            <a href="mailto:office@ueg.eu">office@ueg.eu</a><br/>
            <br/>
            <a href="tel:+43 1 997 1639">T: +43 1 997 1639</a><br/>
            <a href="tel:+43 1997 1639 10">F: +43 1997 1639 10</a>
          </p>
        </div>

        <div class="footer-main-col">
          <p>UEG E-learning</p>
        <br/>
          <p>Ulrike Kapp-Popov</p>
          <p>
            <a href="mailto:e-learning@ueg.eu">e-learning@ueg.eu</a><br/>
            <a href="tel:+43 699 1997 1616">T: +43 699 1997 1616</a><br/>
            <a href="tel:+43 1997 1639 10">F: +43 1997 1639 10</a>
          </p>
        </div>

        <div class="footer-main-col">
          <p>More</p>
        <br/>
            <p><a href="https://ueg.eu/imprint">Imprint</a></p>
            <p><a href="https://ueg.eu/terms-conditions">Terms &amp; Conditions</a></p>
            <p><a href="https://ueg.eu/press">Media Policies</a></p>
            <p><a href="https://ueg.eu/privacy-policy">Privacy Policies</a></p>
        </div>
            
        <div class="footer-main-col">
          <p> Social Media</p>
          <br/>
            <p>
              <a class="social-link" href="https://www.facebook.com/myUEG">
              <img src={Facebook} alt="facebook-icon"/>
                <span id="UEG_Facebook_Count"></span> Followers
              </a>
            </p>
            <p>
              <a class="social-link" href="https://twitter.com/my_ueg">
                <img src={Twitter} alt="twitter-icon"/>
                <span id="UEG_Twitter_Count"></span> Followers
              </a>
            </p>
            <p>
              <a class="social-link" href="https://www.instagram.com/my_ueg/">
                <img src={Instagram} alt="instagram-icon"/>
                <span id="UEG_Instagram_Count"></span> Followers
              </a>
            </p>
            <p>
              <a class="social-link" href="https://www.youtube.com/user/UEGSecretariat">
                <img src={Youtube} alt="youtube-icon"/>
                <span id="UEG_YouTube_Count"></span> Subscribers
              </a>
            </p>
        </div>    
        
        </div>
       
      </footer>
      <div class="footer-row copyright">
    <div class="footer-col">
      <div class="footer-copyright-wrapper" role="navigation" aria-label="Legal">
        UEG copyright
        <script>document.write(new Date().getFullYear())</script> 2023. All rights reserved. Use of this website constitutes
        acceptance of the <a href="https://ueg.eu/terms-conditions">General Terms and Conditions</a> and the <a href="https://ueg.eu/privacy-policy">Privacy Policy</a>.
      </div>
    </div>
  </div>
      </div>
    );
  }
}

SiteFooter.contextType = AppContext;

SiteFooter.propTypes = {
  intl: intlShape.isRequired,
  logo: PropTypes.string,
  onLanguageSelected: PropTypes.func,
  supportedLanguages: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
};

SiteFooter.defaultProps = {
  logo: undefined,
  onLanguageSelected: undefined,
  supportedLanguages: [],
};

export default injectIntl(SiteFooter);
export { EVENT_NAMES };
